import { RouteProps } from "react-router";
import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";

import * as selectors from "src/bepaid/store/model/Fetch/selectors";
import * as actions from "src/bepaid/store/model/Fetch/actions";

import Component from "./View";

const mapStateToProps = (state: RootState) => ({
  accountCountryCode: selectors.getAccountCountryCode(state),
  accountCurrencyId: selectors.getAccountCurrencyId(state),
  accountProfile: selectors.getCurrentAccountProfile(state),
  isSingaporeAccount: selectors.isSingaporeAccount(state),
  getControl: (name: string, form: string) =>
    selectors.getControl(state, name, form)
});

const mapDispatchToProps = {
  setControl: actions.setControl,
  toggleModal: actions.toggleModal,
  updateAdditionalData: actions.updateAdditionalData,
  changeUserSetting: actions.changeUserSetting,
  fetchAccountProfiles: actions.fetchAccountProfiles,
  exchangeToken: actions.exchangeToken
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps;

export default connect(mapStateToProps, mapDispatchToProps)(Component);
